export default "__VITE_ASSET__34194510__"